<template>
    <v-app>
        <template v-if="isAppReady">
            <!-- if user is authenticated -->
            <!-- full-page screens (e.g. the executive dashboard) bring their own header and navigation -->
            <template v-if="isLoggedIn && isFullPage">
                <router-view />
            </template>
            <template v-else-if="isLoggedIn">
                <Header @sidebarToggled="toggleDrawer" />
                <!--<Sidebar ref="sideBar" />-->
                <!--<v-main :class="{ 'main-content--sidebar-closed': !status }" :style="`padding-top: ${ paddingFromTop }px`">
                    <v-container fluid class="mt-4">
                        <router-view />
                    </v-container>
                </v-main>-->
                <v-card color="#f5f7f7" class="elevation-0" min-height="63vh" :style="`padding-top: ${ paddingFromTop }px`">
                    <router-view />
                </v-card>
                <AnonymousFooter></AnonymousFooter>
                <SurveyAI @openai="openai=true;openchat=false" v-model="openai"/>
            </template>
            <!-- if user is not authenticated -->
            <template v-else>
                <AnonymousHeader ></AnonymousHeader>
                <v-card class="elevation-0" min-height="63vh" :style="`padding-top: ${ paddingFromTop }px`">
                    <router-view />
                </v-card>
                <AnonymousFooter v-if="isNotPublicSurvey"></AnonymousFooter>
            </template>
            <ChatBot v-model="openchat" @openchat="openai=false;openchat=true"  v-if="isNotPublicSurvey && !isFullPage" />

        </template>

        <!-- if translation is not yet loaded -->
        <template v-else>
            <SiteOverlay />

        </template>

        <Notification ref="notification" />
        <ConfirmDialog ref="confirm" />
    </v-app>
</template>

<script>
    import '@/assets/css/site.css'
    import { mapGetters } from 'vuex'
    import { isReady } from '@/plugins/i18n/index'

    import Header from '@/components/layout/Header.vue'
    import AnonymousHeader from '@/components/layout/AnonymousHeader.vue'
    import AnonymousFooter from '@/components/layout/AnonymousFooter.vue'
    //import Sidebar from '@/components/layout/Sidebar.vue'
    import SiteOverlay from '@/components/controls/SiteOverlay.vue'
    import Notification from '@/components/controls/Notification.vue'
    import ConfirmDialog from '@/components/controls/ConfirmDialog.vue'
    import ChatBot from '@/components/controls/ChatBot.vue'
    import SurveyAI from '@/components/controls/SurveyAI.vue'
    export default {
        name: 'App',
        components: {
            Header,
            AnonymousHeader,
            AnonymousFooter,
            //Sidebar,
            SiteOverlay,
            Notification,
            ConfirmDialog,
            ChatBot,
            SurveyAI
        },
        data() {
            return {

                status: true,
                openai:false,
                openchat:false
            }
        },
        computed: {
            ...mapGetters('user', ['isAuthenticated']),

            isLoggedIn() {
                return this.isAuthenticated && this.$route.name != 'login'
            },
            isNotPublicSurvey(){
                return this.isLoggedIn || (this.$route.name != 'form' || this.$route.query.viewMode)
            },
            isFullPage() {
                return this.$route.matched.some(r => r.meta && r.meta.fullPage)
            },
            isAppReady() {
                return isReady()
            },
            paddingFromTop() {
                if (this.isNotPublicSurvey)
                    return window.scrollY > 50 ? 100 : 120
                else {
                    return 0
                }
            }

        },
        methods: {
            toggleDrawer() {
                this.status = this.$refs.sideBar.mini
                this.$refs.sideBar.mini = !this.status
            }
        },
        mounted() {
            this.$root.$notification = this.$refs.notification.open
            this.$root.$confirm = this.$refs.confirm.open
        },
    }
</script>
<style>
    @media(max-width:768px) {
        .v-main {
            padding-right: 0px !important
        }

        header {
            right: 0px !important
        }

        .hometitle {
            display: none
        }

        .homespacer {
            display: none
        }

        .v-toolbar__content {
            justify-content: space-between
        }
    }
</style>
